import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=0ff0a79a&scoped=true&lang=html"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0a79a",
  null
  
)

export default component.exports